const l = ({
  businessGroups: s,
  selectionGroupIds: t,
  sections: i
}) => {
  const r = t?.length === 1 && t[0] === -1;
  if (s?.length === 0 && r)
    return !0;
  const o = new Set(t), c = new Set(s);
  return i.filter((n) => n.groups.some((e) => o.has(e.id))).every((n) => n.groups.filter((e) => o.has(e.id)).some((e) => c.has(e.id)));
};
export {
  l as isBusinessInEverySelectedGroupSection
};
